import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ManualDetail from "./components/Manual_detail/ManualDetail";
import ManualsList from "./components/Manual_List/ManualsList";
import { ModelViewerWrapper } from "./components/Viewers/modelViewerWrapper";
import { LanguageProvider } from "./components/LanguageContext";
import Login from "./components/Login/Login";
import PrivateRoute from "./components/PrivateRoute";
import JwtExpirationHandlerComponent from "./JwtExpirationHandlerComponent";
import ForgotPassword from "./components/Forgot_Reset/Forgotpassword";
import AddPackage from "./admin/Packages/AddPackage";
import AddLicense from "./admin/Licenses/AddLicense";
import "./App.css";
import PackagesList from "./admin/Packages/PackagesList";
import EditStep from "./admin/Packages/EditStep";
import CreateStep from "./admin/Packages/CreateStep";
import CategoriesList from "./admin/Categories/CategoriesList";
import LicensesList from "./admin/./Licenses/LicensesList";
import Resetpassword from "./components/Forgot_Reset/Resetpassword";
import StepList from "./admin/Packages/StepList";
import AddCategory from "./admin/Categories/AddCategory";
import SubcategoriesList from "./admin/Categories/SubcategoriesList";
import CreateSubcategory from "./admin/Categories/CreateSubcategory";
import EditSubcategory from "./admin/Categories/EditSubcategory";
import ThemeProvider from "./hooks/themeContext";

const AppRoutes = () => (
  <div className="font-sans">
    <Routes>
      <Route path="/forgotten-password" element={<ForgotPassword />} />
      <Route path="/login" element={<Login />} />
      <Route path="/resetpassword/:token" element={<Resetpassword />} />
      <Route path="/resetpassword" element={<Resetpassword />} />
      <Route path="/" element={<ManualsList />} />
      <Route path="/selected/detail/:guideId" element={<ManualDetail />} />
      <Route path="/viewer" element={<ModelViewerWrapper />} />
      <Route path="/" element={<PrivateRoute />}>
        <Route path="/add-package" element={<AddPackage />} />
        <Route path="/add-package/:id" element={<AddPackage />} />
        <Route path="/create-step/:id" element={<CreateStep />} />
        <Route path="/edit-step/:id" element={<EditStep />} />
        <Route path="/categories-list/" element={<CategoriesList />} />
        <Route path="/subcategories-list" element={<SubcategoriesList />} />
        <Route path="/add-category" element={<AddCategory />} />
        <Route path="/add-subcategory/:id" element={<CreateSubcategory />} />
        <Route path="/edit-category/:id" element={<AddCategory />} />
        <Route path="/edit-subcategory/:id" element={<EditSubcategory />} />
        <Route path="/licenses-list" element={<LicensesList />} />
        <Route path="/add-license" element={<AddLicense />} />
        <Route path="/add-license/:id" element={<AddLicense />} />
        <Route path="/steps-list" element={<StepList />} />
        <Route path="/steps-list/:id" element={<StepList />} />
        <Route path="/packages-list" element={<PackagesList />} />
      </Route>
    </Routes>
  </div>
);

const App = () => (
  <ThemeProvider>
    <LanguageProvider>
      <Router>
        <JwtExpirationHandlerComponent />
        <AppRoutes />
      </Router>
    </LanguageProvider>
  </ThemeProvider>
);

export default App;
